module.exports = __webpack_public_path__ + "img/21.beee5e2b.svg";